/**
 * @fileoverview Okta SDK Configuration for Autolabs
 *
 * Configures @okta/okta-auth-js for SPA authentication with PKCE.
 * This configuration is used by both the OktaAuth instance and the Vue plugin.
 */

import { OktaAuth } from '@okta/okta-auth-js'

/**
 * Okta SDK configuration
 * @type {import('@okta/okta-auth-js').OktaAuthOptions}
 */
export const oktaConfig = {
  // Identity Provider
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,

  // Redirect URIs
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: window.location.origin,

  // OAuth settings
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true, // REQUIRED for SPA
  responseType: 'code',

  // Token management
  tokenManager: {
    autoRenew: true, // Automatically refresh tokens
    autoRemove: true, // Remove expired tokens
    secure: true, // Use secure cookies where available
    storage: 'sessionStorage', // More secure than localStorage
    expireEarlySeconds: 120 // Renew 2 minutes before expiration
  },

  // Services
  services: {
    autoRenew: true,
    syncStorage: true // Sync across tabs
  },

  // Restore original URI after login
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    // Router will handle redirect after callback
    window.location.replace(originalUri || '/')
  }
}

/**
 * Create singleton OktaAuth instance
 */
export const oktaAuth = new OktaAuth(oktaConfig)

// Start services (auto-renew, etc.)
oktaAuth.start()

export default oktaAuth
